const routes = [

	
	//---- "Mobile App" web view pages 
	//     (for direct access from the mobile app, either in a web view or in a native browser)
	//NOTE: These are from the original version of the Lotus app, for the [now deleted] quoting module.
	//NOTE: Keeping these here for reference.
	{ 
		path: '/mobile-app/manage-jobs',
		name: "mobile-app-manage-jobs", 
		component: () => import("/mobile-app/manage-jobs.vue"),
		meta: { layout: "mobileappembeddedview", layoutType: "default", layoutContainer: "card", pageTitle: "Manage Jobs" }
	},
	{ 
		path: '/mobile-app/new-job',
		name: "mobile-app-new-job", 
		component: () => import("/mobile-app/edit-job.vue"),
		meta: { layout: "mobileappembeddedview", layoutType: "default", layoutContainer: "card", pageTitle: "New Job" }
	},
	{ 
		path: '/mobile-app/edit-job/:jobId',
		name: "mobile-app-edit-job", 
		component: () => import("/mobile-app/edit-job.vue"),
		meta: { layout: "mobileappembeddedview", layoutType: "default", layoutContainer: "card", pageTitle: "Modify Job" }
	},




















	//---- "Mobile App" V2 - a web native "app" for running in the browser.
	{ 
		path: '/app/home',
		name: "mobile-app-home", 
		component: () => import("/mobile-app/home.vue"),
		meta: { layout: "mobileapp", layoutType: "default", layoutContainer: "card", pageTitle: "Home" }
	}

















]


export default routes;